import React from "react";
import "./index.css";
import "./animations.css";
// import "./global.css";
import { createRoot } from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./i18n";

import GlobalProvider from "./context";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GlobalProvider>
      <App />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={true}
        draggable={true}
        progress={undefined}
        theme="light"
        type="success"
      />
    </GlobalProvider>
  </React.StrictMode>
);

// Installable dashboard (PWA) — see public/sw.js. Production only, so the dev server never serves cached files.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
